import { DialogContent } from "@mui/material";
import {
  BottomSheet,
  BottomSheetIllustrationContent,
  type UseModalState,
} from "@src/appV2/redesign/system/ui-components";
import { generatePath, useHistory } from "react-router-dom";

import { Button } from "../../components/Button";
import { DialogFooter } from "../../components/DialogFooter";

interface LicenseDuplicateBottomSheetProps {
  modalState: UseModalState;
  roleDetailsPath: string;
  qualificationId: string;
}

export function AddLicenseDuplicateBottomSheet(props: LicenseDuplicateBottomSheetProps) {
  const { modalState, roleDetailsPath, qualificationId } = props;
  const history = useHistory();

  // We need to override the closeModal function to call the onSubmittedCtaClick function,
  // because we direct to a different page (backdrop page) when the user clicks the button.
  modalState.closeModal = () => {
    history.replace(
      generatePath(roleDetailsPath, {
        qualificationId,
      })
    );
    modalState.setModalStatus("closed");
  };

  return (
    <BottomSheet
      footer={
        <DialogFooter orientation="vertical">
          <Button
            fullWidth
            size="large"
            variant="contained"
            onClick={() => {
              history.replace(
                generatePath(roleDetailsPath, {
                  qualificationId,
                })
              );
            }}
          >
            Update existing license
          </Button>
        </DialogFooter>
      }
      modalState={modalState}
    >
      <DialogContent sx={{ padding: 5, paddingTop: 8 }}>
        <BottomSheetIllustrationContent
          illustrationType="document-rejected"
          title="License already exists"
          description="You already have a license for this qualification in this state."
        />
      </DialogContent>
    </BottomSheet>
  );
}
